import { __assign } from "tslib";
// DS8.14
import React from 'react';
import IconWrap from '../../IconWrap';
var DAProtect = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12 3L5 6.09091V10.7273C5 14.9773 7.95556 18.9955 12 20C16.0444 18.9955 19 14.9773 19 10.7273V6.09091L12 3ZM10.9385 15.8353L10.7626 16H9V14.3635L10.7771 11.2116L10.6318 11.0473H9V8.79997H11.9684L12.2299 8.63621L13.0615 7.16459L13.2375 7H15V8.63636L13.2229 11.7894L13.3682 11.9527H15V14.1999H12.0317L11.7703 14.3638L10.9385 15.8353Z" })))); };
DAProtect.displayName = 'DAProtect';
export default DAProtect;
//# sourceMappingURL=DAProtect.js.map